import React from 'react';

const MultipleFamilyMatches: React.FC = () => {
	return (
		<div className="center-center-content">
			<div className="online-booking__error-code-component">
				<div className="text">
					<p>We’re sorry! We found multiple matches in our system.</p>
					<p>
						Please call us at
						{' '}
						<span className="inline-block">
							<a href="tel:8559335683" className="inline-link">(855) 933-5683</a>
						</span>
						{' '}
						to help adjust your family information.
					</p>
				</div>
			</div>
		</div>
	);
};

export default MultipleFamilyMatches;
